import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import ENV from "glesys-controlpanel/config/environment";

export default class ModalsExportZoneFile extends Component {
  @service modal;
  @service ajax;
  @service notification;
  @service intl;

  get domain() {
    return this.args.params.domain;
  }

  get fileObjectUrl() {
    let data = new Blob([this.file], { type: "text/txt" });
    let fileObjectUrl = URL.createObjectURL(data);

    return fileObjectUrl;
  }

  @tracked file = "";

  exportFile = task(async () => {
    try {
      let response = await this.ajax.post(`${ENV.apiBaseUri}/domain/export`, {
        data: {
          domainname: this.domain.id,
        },
      });
      this.file = response.zonefile;
    } catch {
      this.notification.add(
        "error",
        this.intl.t("dns.domain.files.notifications.title"),
        this.intl.t("dns.domain.files.notifications.error-text"),
      );
      this.modal.close();
    }
  });
}
